









































































































































































  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import appconst from '@/lib/appconst';
  import SeverUrl from "@/lib/url";
  import letterInfo from "@/store/entities/jm/hzbletter";
  import elementResizeDetector from "element-resize-detector";
  @Component({
    components:{}
  })
  export default class HZBLetterEdits extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:"0"}) letterid:string;
    @Prop({type:Number,default:0}) sendway:number;
    loadingInstance:boolean=false;
    finding:boolean=false;
    loading:boolean=false;
    modalWidth=window.innerWidth * 0.7;
    currentModel:letterInfo = new letterInfo();
    indexRow:string="";
    indexCol:string="";
    selectRow= [];
    downloading:boolean=false;
    title:string ="银行函证";
    statusBtn:number=0;
    activeNames=['1'];

    selectable(row, index) {
      return this.statusBtn>0?false:true;
    }
    cellClick(row,column,cell) {
      this.indexRow = row.index;
      this.indexCol = column.index;
      this.$nextTick(() => {
        if(column.index===2){
          if(this.$refs["amount"+this.indexRow]){
            (this.$refs["amount"+this.indexRow] as any).focus();
          }
        }
        if(column.index===3){
          if(this.$refs["remark"+this.indexRow]){
            (this.$refs["remark"+this.indexRow] as any).focus();
          }
        }
      });
    }
    updateBegin(){
      this.indexRow="";
      this.indexCol="";
    }
    handleSelectionChange(selection) {
      this.selectRow=selection;
    }
    bankLists= [];
    formatList=[{value:'1',text:'会所主填',label:'格式一',disabled:true},{value:'2',text:'银行主填',label:'格式二',disabled:true},{value:'3',text:'验资',label:'格式三',disabled:true}];
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    bankChange(value) {
      let lists = this.bankLists.find(item => item.label === value);
      if(lists){
          this.currentModel.bankTopId=lists.value;
          this.currentModel.bankCnaps=lists.cnaps;
          this.formatList[0].disabled=lists.fmt1=='1'?false:true;
          this.formatList[1].disabled=lists.fmt2=='1'?false:true;
          this.formatList[2].disabled=lists.fmt3=='1'?false:true;
      }
      else{
         this.currentModel.bankTopId='0';
         this.currentModel.bankCnaps='';
         this.formatList[0].disabled=true;
         this.formatList[1].disabled=true;
         this.formatList[2].disabled=true;
      }
      this.currentModel.hzFormat="";
    }
    formatChange(value){
      if(value=='2'&&this.sendway==0){
        this.saveRules.outfileimport[0].required=false;
        if(this.letterid=='0'){
        let duedate=this.currentModel.dueDate;
        if(this.currentModel.hzbLetterItem&&this.currentModel.hzbLetterItem.length>0){
          this.currentModel.hzbLetterItem.forEach((item,index)=>{
                  if(index!==2){
                    item.beginDate=duedate;
                  } 
                  item.endDate=duedate;
              })
        }}
      }
      else{
        this.saveRules.outfileimport[0].required=true;
      }
    }
    async DownOutFile(row:any){
      this.downloading=true;
      await this.$store.dispatch({
          type:'hzbletter/downOutFile',
          data:{HzId:row.hzId,id:row.id,filename:row.name}
      });
      this.downloading=false;
    }
    async downFormat(formatid){
       var id,filename;
       switch(Number(formatid)){
        case 1:
          id="BPBC_Format1.xls";
          filename="BPBC_Format1.xls";
          break;
        case 2:
          break;
        case 3:
          id="BPBC_Format3.xls";
          filename="BPBC_Format3.xls";
          break;
        case 4:
          id="2024BankTemplate.docx";
          filename="2024纸质银行函证模板.docx";
          break;
       }
       let response = await this.$store.dispatch({
            type: "hzbletter/downloadImportTemplate",
            data: {id:id,filename:filename}
        });
    }
    async renewFormat(){
      let bname=this.currentModel.bankName;
      if(bname&&bname!=""){
         this.$confirm('确定要重新获取该银行所支持的格式信息吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async() => {
              this.loadingInstance=true;
              var currid=this.$store.state.jobdo.currjob;
              let result=await this.$store.dispatch({
                  type:'hzbletter/renewformat',
                  data:{id:currid,bankname:bname}
              });
              this.loadingInstance=false;
              if(result&&result.length>0){
                this.formatList[0].disabled=result[0].bpbcFormat1=='1'?false:true;
                this.formatList[1].disabled=result[0].bpbcFormat2=='1'?false:true;
                this.formatList[2].disabled=result[0].bpbcFormat3=='1'?false:true;
                  this.$alert('刷新已完成','提示',{type:'info'});
              }
              else{
                this.$alert('刷新失败或未能成功获取信息','提示',{type:'info'});
              }
          })
          .catch(() => {this.loadingInstance=false;});
      }
      else{
        this.$alert('银行名称不能为空','提示',{type:'info'});
      }
    }
    beginChange(value){
      if(this.indexRow!==""){
        let index=Number(this.indexRow);
        this.currentModel.hzbLetterItem[index].beginDate=value;
      }
      this.indexRow="";
    }
    endChange(index,value){
      if(this.indexRow!==""){
        let index=Number(this.indexRow);
        this.currentModel.hzbLetterItem[index].endDate=value;
      }
      this.indexRow="";
    }
    dateChange(value){
      this.currentModel.dueDate=value;
      if(this.currentModel.hzbLetterItem&&this.currentModel.hzbLetterItem.length>0){
        this.currentModel.hzbLetterItem.forEach((item,index)=>{
                if(index!==2){
                    item.beginDate=value;
                  } 
                item.endDate=value;
            })
      }
    }
    async queryBankName (query) {
        if (query !== ''&&query.length>=2) {
            this.finding = true;
            let result=await this.$store.dispatch({
                type:'hzbletter/getBankName',
                data:{keyword:query}
            });
            if(result&&result.length>0){
                setTimeout(() => {
                this.finding = false;
                const list = result.map(item => {
                    return {
                        value: item.id,
                        label: item.bankName,
                        cnaps:item.bankCnaps,
                        fmt1:item.bpbcFormat1,
                        fmt2:item.bpbcFormat2,
                        fmt3:item.bpbcFormat3
                    };
                });
                this.bankLists = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
            }, 200);
            }
            else {
                this.bankLists = [];
            }
            
        } else {
            this.bankLists = [];
        }
        this.finding=false;
    }
    cellClass({row,column,rowIndex,columnIndex}){
        if(columnIndex === 2||columnIndex === 3){
          if(columnIndex===2&&rowIndex===2){
            return 'padding: 6px;background:#f5f5f5';
          }
          return 'padding: 6px;background:AliceBlue;font-weight:bold';
        }
        else{
          return 'padding: 6px';
        }
    }
    cellClassName({row, column, rowIndex, columnIndex}){
        row.index = rowIndex;
        column.index = columnIndex;
    }
    saveRules={
      bankName:[{required:true,message: '银行名称不能为空',trigger: 'blur'}],
      hzFormat:[{required:true,message:'请选择发函格式',trigger: 'blur'}],
      dueDate:[{required:true,message:'函证基准日不能为空',trigger: 'change',pattern: /.+/ }],
      nbankAcct:[{required:true,message: '授权账号不能为空',trigger: 'blur'}],
      bankCnaps:[{required:true,message: '联行号不能为空',trigger: 'blur'}],
      outfileimport:[{required: true,validator: this.checkOutFileCount, trigger: 'blur' }],
      postAddr:[{required:true,message: '寄送地址不能为空',trigger: 'blur'}],
      contactName:[{required:true,message: '联系人不能为空',trigger: 'blur'}],
      contactTel:[{required:true,message: '联系电话不能为空',trigger: 'blur'}]
    }
    checkOutFileCount(rule, value, callback){
       if (this.currentModel.outFileName.length===0) {
         callback(new Error('请先上传发函文件'));
       }else {
         callback();
       }
    }
   fileonChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$alert('上传文件不能超过99M','提示',{type:'info'});
        fileList.pop();
      }
      this.currentModel.outFileName = fileList.slice(-1);
      (this.$refs["bletterRef"] as any).validateField('outfileimport');
  }
  fileonRemove (file, fileList) {
    this.currentModel.outFileName = fileList;
  }
  fileonDelete (file) {
    let uploadFiles = (this.$refs["outfileupload"] as any).uploadFiles;
    for (var i = 0; i < uploadFiles.length; i++) {
      if (uploadFiles[i]['uid'] == file.uid) {
        uploadFiles.splice(i, 1)
      }
    }
    this.currentModel.outFileName=uploadFiles;
  }
    formatCurrency (num) {
        return Util.format.amount(num);
    }
  async itemChange(){}
  visibleChange(value) {
      if (!value) {
        this.activeNames=['1'];
        (this.$refs["bletterRef"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        this.getItem();
      }
   }
   async del(){
      var currid=this.$store.state.jobdo.currjob;
        let response=await this.$store.dispatch({
            type:'hzbletter/deletebletter',
            data:{ProjectId:currid,HzId:this.letterid}
        });
        if(response.success){
            this.$message({
              message: '已删除',
              type: 'success'
            });
            this.loading=false;
            (this.$refs["bletterRef"] as any).resetFields();
            this.$emit('input',false);
            this.$emit('save-success');
        }
        else{
            this.$alert(response.message,'提示',{type:'info'});
            this.loading=false;
        }
    }
    cancel(){
      (this.$refs["bletterRef"] as any).resetFields();
      this.$emit('input',false);
    }
    async getItem(){
      this.loadingInstance=true;
       let currid=this.$store.state.jobdo.currjob;
       var response=await this.$store.dispatch({
           type:'hzbletter/getitem',
           data:{Id:currid,LetterId:this.letterid}
       });
       if(response.length>0){
          let sendway="电子函证";
          if(this.sendway==1){
            sendway="纸质函证";
          }
          this.currentModel=Util.extend(true,{},response[0]);
          this.title=this.currentModel.aName+'>银行函证>'+this.currentModel.custName+'>'+sendway+this.currentModel.hzSn;
          if(this.sendway==1){
            this.saveRules.bankCnaps[0].required=false;
            this.saveRules.postAddr[0].required=true;
            this.saveRules.contactName[0].required=true;
            this.saveRules.contactTel[0].required=true;
          }else{
            this.saveRules.bankCnaps[0].required=true;
            this.saveRules.outfileimport[0].required=true;
            this.saveRules.postAddr[0].required=false;
            this.saveRules.contactName[0].required=false;
            this.saveRules.contactTel[0].required=false;
          }
          this.statusBtn=Number(this.currentModel.status);
          var chkdata=[];
          this.currentModel.hzbLetterItem.forEach(element => {
            if(element.id>0){
                chkdata.push(element);
            }
          });
          setTimeout(() => { 
            if(chkdata.length>0){
              this.toggleSelection(chkdata);
            }
          }, 100);
      } 
      this.loadingInstance=false;
   }
   toggleSelection(rows) {
    if (rows) {
      rows.forEach(row => {
        (this.$refs.hzbLetterTable as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.hzbLetterTable as any).clearSelection();
    }
  }
  async approval(){
   await this.save(1);
   }
   async save(status:number) {
        (this.$refs.bletterRef as any).validate(async (valid:boolean)=>{
            if(valid){
              let arrs=[];
              if(this.currentModel.hzFormat=='2'&&this.sendway==0){
                  let sheets=(this.$refs['hzbLetterTable'] as any).selection;
                  if(sheets.length>0){
                      for(var k=0;k<sheets.length;k++){
                          if(sheets[k].beginDate==''){
                            this.$alert('起始日期不能为空。','提示',{type:'info'});
                            return false;
                          }
                          if(sheets[k].endDate==''){
                            this.$alert('截至日期不能为空。','提示',{type:'info'});
                            return false;
                          }
                          arrs.push(sheets[k]);
                      }
                  }
                  else{
                    this.$alert('至少选择一个函证项。','提示',{type:'info'});
                    return false;
                  }
              }
              let currid=this.$store.state.jobdo.currjob;
              
              var formData = new FormData(); 
              formData.append('ProjectId',currid);
              formData.append('HzId',this.letterid);
              formData.append('SendWay',this.sendway.toString());
              formData.append('HzFormat',this.currentModel.hzFormat);
              formData.append('DueDate',this.currentModel.dueDate);
              formData.append('CustName',this.currentModel.custName);
              formData.append('BankTopID',this.currentModel.bankTopId);
              formData.append('BankName',this.currentModel.bankName);
              formData.append('NBankAcct',this.currentModel.nbankAcct);
              formData.append('BankCnaps',this.currentModel.bankCnaps);
              formData.append('Remark',this.currentModel.remark);
              formData.append('Status',status.toString());
              formData.append('PostAddr',this.currentModel.postAddr);
              formData.append('ContactName',this.currentModel.contactName);
              formData.append('ContactTel',this.currentModel.contactTel);
              formData.append('HzbLetterItems',JSON.stringify(arrs));
              this.currentModel.outFileName.forEach(file => { 
                  if(file.status=='ready'){
                    formData.append('outFile', file.raw, file.raw.name); 
                  }
              })
              if(status==1){
                  this.$confirm('确定将该函证推进到待发送状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(async() => {
                      this.loadingInstance=true;
                      let result=await this.$store.dispatch({
                          type:'hzbletter/savebletter',
                          data:formData
                      });
                      this.loadingInstance=false;
                      if(result&&result.success){
                          (this.$refs.bletterRef as any).resetFields();
                          this.$emit('save-success');
                          this.$emit('input',false);
                      }
                      else{
                        this.$alert(result.message,'提示',{type:'info'});
                      }
                  })
                  .catch(() => {});
              }else{
                this.loadingInstance=true;
                let result=await this.$store.dispatch({
                    type:'hzbletter/savebletter',
                    data:formData
                });
                this.loadingInstance=false;
                if(result&&result.success){
                    (this.$refs.bletterRef as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
                else{
                  this.$alert(result.message,'提示',{type:'info'});
                }
              }
              
            }
        })
    }
    async created(){}
    async mounted(){
       const that = this;
       var modalH=window.innerHeight-188; 
       var erd = elementResizeDetector();
       erd.listenTo(document.querySelectorAll("#bletteredit .ivu-modal-content"), (element) => {              
        that.$nextTick(() => { 
            let ivumodal=$(".modal-bletter > div.ivu-modal");
            if(ivumodal){
              if(that.currentModel.hzFormat=='2'&&that.sendway==0){
                ivumodal.css('top','45px');
              }
              else{
                ivumodal.css('top','100px');
              }
            }
            let modalbody=$(".modal-bletter > div.ivu-modal > div.ivu-modal-content > div.ivu-modal-body");
            if(modalbody){
               if(that.currentModel.hzFormat=='2'&&that.sendway==0){
                if(modalH<480){
                  modalbody.css('max-height','480px');
                }
                else{
                  modalbody.css('max-height',modalH+'px');
                }
               } 
               else{
                  modalbody.css('max-height','480px');
               }
            }
        });
      });
    }
}
  